import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';

import modalStyles from 'shared/components/modalStyles';
import PriceGuide from 'app/components/PriceGuide';
import messages, { FormattedMessage } from 'shared/messages/messages';
import config from 'shared/config/config';

import {
  viewGallery,
  viewCart
} from 'app/actions/kioskActions';

import {
  trackEvent
} from 'shared/services/Analytics';

import {
  MARKETPLACE_CHECKOUT_TYPE
} from 'app/utils/Constants';

const styles = theme => ({
  toolbar: {
    position: 'fixed',
    zIndex: 99998,
    top: '2.85rem',
    left: 0,
    right: 0,
    height: '4.8rem',
    background: '#fdfdfd',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    padding: '0.5rem 1rem'
  },
  headerWrapper: {
    float: 'left'
  },
  header: {
    fontSize: '1.2rem',
    fontWeight: 700,
    textAlign: 'left',
    marginTop: '0.1rem',
    marginBottom: '0.5rem',
    fontFamily: config.root_font_family
  },
  actions: {
    float: 'right',
    marginTop: '0.5rem',
    cursor: 'pointer'
  },
  browseText: {
    textAlign: 'left',
    fontSize: '0.8rem',
    marginBottom: '0.5rem',
    paddingBottom: 0,
    fontFamily: config.root_font_family
  },
  reviewOrder: {
    float: 'right',
    textAlign: 'center',
    padding: '0.5rem 1.3rem',
    fontWeight: 600,
    background: 'linear-gradient(#4ea4c3, #007aa1)',
    borderRadius: '3px',
    border: 'none',
    color: '#fff',
    fontFamily: config.root_font_family,
    fontSize: config.root_font_size
  },
  priceGuideButton: {
    float: 'right',
    textAlign: 'center',
    marginRight: '2rem',
    padding: '0.5rem 1.3rem',
    fontWeight: 600,
    background: 'linear-gradient(#ffffff, #f1f1f1)',
    borderRadius: '3px',
    border: '1px solid #dcdcdc',
    boxShadow: '0 0 2px #dcdcdc',
    color: '#2b8eb0'
  },
  priceGuideIcon: {
    marginTop: '-0.2rem',
    marginRight: '0.2rem'
  },
  cartCount: {
    float: 'right',
    fontSize: '1.3rem',
    fontWeight: 600,
    marginTop: '-0.2rem',
    marginRight: '0.5rem',
    padding: '0.5rem 0',
    textTransform: 'uppercase',
    color: '#2b8eb0',
    fontFamily: config.root_font_family
  },
  cartIcon: {
    fontSize: '1.8rem',
    marginTop: '-0.2rem',
    marginLeft: '0.4rem'
  },
  ...modalStyles()
});

class CatalogToolbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showPriceGuide: false
    }
  }

  viewGallery() {
    const { settings, user, viewGallery, viewCart } = this.props;

    if (settings.gallery_screen) {
      viewGallery();
    } else if (settings.cart_screen) {
      viewCart();
    }

    trackEvent('Kiosk.ViewCart', {
      userId: user.id,
      storyId: user.story_id,
      kiosk: settings.token
    });
  }

  showPriceGuide() {
    this.setState({showPriceGuide: true});
  }

  closePriceGuide() {
    if (this.state.showPriceGuide) {
      this.setState({ showPriceGuide: false });
      window.currentModal.close();
      document.body.style.overflowY = 'auto';
    }
  }

  renderPriceGuide() {
    return (
      <PriceGuide open={this.state.showPriceGuide} onClose={this.closePriceGuide.bind(this)} />
    );
  }

  render() {
    const {
      classes,
      settings,
      selectedMomentIds
    } = this.props;

    let header, msg, btn, cartIcon;
    if (settings.gallery_screen) {
      header = messages.kiosk_catalog_header;
      msg = messages.kiosk_catalog_instructions;
      btn = messages.button_view_my_gallery;
      cartIcon = <PhotoLibraryIcon className={classes.cartIcon} />;

    } else {
      header = messages.kiosk_catalog_header_no_gallery;
      msg = messages.kiosk_catalog_instructions_no_gallery;
      btn = messages.button_review_and_purchase;
      cartIcon = <ShoppingCartIcon className={classes.cartIcon} />;
    }

    let selectedCount = selectedMomentIds.length;

    let priceGuideBtn = null;
    if (settings.checkout_type === MARKETPLACE_CHECKOUT_TYPE) {
      priceGuideBtn = (
        <button className={classes.priceGuideButton} onClick={this.showPriceGuide.bind(this)}>
          <MonetizationOnIcon className={classes.priceGuideIcon} />
          <FormattedMessage {...messages.button_price_guide} />
        </button>
      );
    }

    return (
      <div className={classes.toolbar}>
        <div className={classes.headerWrapper}>
          <p className={classes.header}>
            <FormattedMessage {...header} />
          </p>
          <p className={classes.browseText}>
            <FormattedMessage {...msg} />
          </p>
        </div>
        <div className={classes.actions}>
          <button className={classes.reviewOrder} onClick={this.viewGallery.bind(this)}>
            <FormattedMessage {...btn} />
          </button>
          <p className={classes.cartCount}>
            <span>{selectedCount}</span>
            {cartIcon}
          </p>
          {priceGuideBtn}
        </div>
        {this.renderPriceGuide()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.kioskReducer.settings,
  user: state.kioskReducer.user,
  dates: state.kioskReducer.dates,
  currentDate: state.kioskReducer.currentDate,
  selectedMomentIds: state.kioskReducer.selectedMomentIds,
  moments: state.cartReducer.moments
});

export default connect(mapStateToProps, { viewGallery, viewCart })(withStyles(styles)(CatalogToolbar));
